'use strict';

$.fn.selectpicker.Constructor.BootstrapVersion = '4';
$('.selectpicker').selectpicker();


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/selectCustom.js